(function () {
	'use strict';



		var header = $('header');
		var triggerPoint = 100;

		$(window).on('scroll', function() {

			if ($(window).scrollTop() > triggerPoint) {
				header.addClass('is-sticky');
			} else {
				header.removeClass('is-sticky');
			}

		});



	// Switching to mobile: https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/onchange
	const isMobile = window.matchMedia(
		'(max-width: ' + getComputedStyle(document.body).getPropertyValue('--custom--media-max-width--sm') + ')'
	);
	const navigationResponsiveContainer = document.querySelector(
		'.site-header .wp-block-navigation__responsive-container'
	);
	isMobile.onchange = (e) => {
		if (e.matches) {
			// <= Mobile
		} else {
			// > Mobile
			// Autoclose header nav container if modal is open and browser window gets resized.
			if (
				document.body.contains(navigationResponsiveContainer) &&
				navigationResponsiveContainer.classList.contains('is-menu-open')
			) {
				document.querySelector('.site-header .wp-block-navigation__responsive-container-close').click();
			}
		}
	};

	// Style password protected post form.
	const passwordButton = document.querySelector('.post-password-form [type="submit"]');
	if (document.body.contains(passwordButton)) {
		const passwordButtonWrapper = document.createElement('div');
		passwordButtonWrapper.classList.add('wp-block-button');
		passwordButton.parentNode.insertBefore(passwordButtonWrapper, passwordButton);
		passwordButtonWrapper.appendChild(passwordButton);

		passwordButton.classList.add('wp-block-button__link');
	}
})();


document.addEventListener('DOMContentLoaded', function() {
	const toggleButton = document.querySelector('.menu-toggle');
	const nav = document.querySelector('.primary-navigation');

	if (!toggleButton || !nav) {
		return;
	}

	const closeMenu = () => {
		nav.classList.remove('active');
		document.body.classList.remove('menu-open');
		toggleButton.setAttribute('aria-expanded', 'false');
	};

	const openMenu = () => {
		nav.classList.add('active');
		document.body.classList.add('menu-open');
		toggleButton.setAttribute('aria-expanded', 'true');
	};

	// Mobile hamburger toggle
	toggleButton.addEventListener('click', function() {
		if (nav.classList.contains('active')) {
			closeMenu();
		} else {
			openMenu();
		}
	});

	window.addEventListener('resize', function() {
		if (window.innerWidth > 767) {
			closeMenu();
		}
	});

	// Add submenu toggle arrows
	const parentItems = document.querySelectorAll('.menu li.menu-item-has-children');

	parentItems.forEach(item => {
		const arrow = document.createElement('span');
		arrow.classList.add('submenu-toggle');
		arrow.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Pro 7.3.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2026 Fonticons, Inc.--><path opacity=".4" d=""/><path d="M320.1 486.6L331.4 475.3L539.4 267.3L550.7 256L528.1 233.4L516.8 244.7L320.1 441.4L123.4 244.7L112.1 233.4L89.5 256L100.8 267.3L308.8 475.3L320.1 486.6z"/></svg>';
		item.insertBefore(arrow, item.querySelector('ul.sub-menu'));

		// Toggle submenu on arrow click
		arrow.addEventListener('click', function(e) {
			e.stopPropagation();
			const submenu = item.querySelector('ul.sub-menu');
			if (submenu) {
				const isOpen = item.classList.contains('submenu-open');
				item.classList.toggle('submenu-open', !isOpen);
				submenu.setAttribute('aria-hidden', String(isOpen));
			}
		});
	});
});